/* eslint-disable no-unused-vars */

import { createContext } from 'react';

export const AuthContext = createContext({
  token: null,
  authenticate: async (nick, senha) => {},
  kanban: (status) => {},
  logout: () => {},
});
